import { ComponentProps, FC } from 'react';
import s from './KeywordsTable.module.scss';
import { Button } from '@tremor/react';
import { XDeleteIcon } from '@/assets';

interface Props extends ComponentProps<typeof Button> {
  tag: string;
  isEditable?: boolean;
}

export const TagCellElement: FC<Props> = ({ tag, isEditable = true, ...rest }) => {
  return (
    <div className={s.tagCellElement}>
      <p>{tag}</p>
      {isEditable ? (
        <Button className={s.deleteTagButton} {...rest}>
          <img src={XDeleteIcon} alt="delete tag icon" />
        </Button>
      ) : null}
    </div>
  );
};
